
import { useEffect, useRef } from 'react';

const GlobalAdUnit = () => {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Only execute this code in the browser
    if (typeof window !== 'undefined' && adRef.current) {
      try {
        // Clear previous content if any
        adRef.current.innerHTML = `
          <!-- Watch an ad -->
          <ins class="adsbygoogle"
               style="display:block"
               data-ad-client="ca-pub-4339436869702682"
               data-ad-slot="1257742356"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>
        `;

        // Push the ad
        // @ts-ignore - adsbygoogle is added by the script in index.html
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        console.log('Global AdSense ad initialized');
      } catch (error) {
        console.error('Error initializing global AdSense ad:', error);
      }
    }
  }, []);

  return (
    <div 
      ref={adRef} 
      className="global-ad-unit my-4" 
      style={{ minHeight: '100px', display: 'block' }}
    />
  );
};

export default GlobalAdUnit;
